import Button from 'ext-ui/components/Button/Button'
import SendIcon from 'ext-ui/svg/icon/SendIcon'
import React, { useEffect, useRef } from 'react'
import styles from 'src/agent/components/AgentChatField/AgentChatField.style'
import { useTranslate } from 'src/localization/Trns'

interface ReportingAgentChatFieldProps {
  value: string
  onChange: (value: string) => void
  onSubmit: () => void
  placeholder: string
  disabled?: boolean
  submitDisabled?: boolean
  loading?: boolean
  focusOnMount?: boolean
}

const ReportingAgentChatField: React.FC<ReportingAgentChatFieldProps> = ({
  value,
  onChange,
  onSubmit,
  placeholder,
  disabled = false,
  submitDisabled = false,
  loading = false,
  focusOnMount = false,
}) => {
  const translate = useTranslate()
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const isDisabled = disabled || loading

  useEffect(() => {
    if (focusOnMount && !isDisabled) textAreaRef.current?.focus()
  }, [focusOnMount, isDisabled])

  return (
    <div css={styles} className="AgentChatField ReportingAgentChatField">
      <div className="flex-row gap-2">
        <div className="textarea-wrapper">
          <textarea
            ref={textAreaRef}
            aria-label={translate('Report request')}
            className="textarea"
            value={value}
            onChange={(event): void => {
              onChange(event.target.value)
              event.currentTarget.style.height = 'auto'
              event.currentTarget.style.height = `${event.currentTarget.scrollHeight}px`
            }}
            onKeyDown={(event): void => {
              if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault()
                onSubmit()
              }
            }}
            placeholder={isDisabled ? '' : placeholder}
            disabled={isDisabled}
            rows={1}
          />
        </div>
        <Button
          type="button"
          className="send-button"
          dropShadow={false}
          aria-label={translate('Send report request')}
          onClick={onSubmit}
          disabled={isDisabled || submitDisabled || value.trim().length === 0}
        >
          <SendIcon aria-hidden="true" />
        </Button>
      </div>
    </div>
  )
}

export default ReportingAgentChatField
